'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Raven from 'raven-js';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';

class GenericErrorBoundary extends PureComponent {
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      hasError: false
    };
  }

  componentDidUpdate(prevProps) {
    const {
      hasError
    } = this.state;

    if (hasError && prevProps.children !== this.props.children) {
      this.setState({
        hasError: false
      });
    }
  }

  componentDidCatch(error, info) {
    Raven.captureException(error, {
      extra: info
    });
  }

  renderError() {
    const {
      fallback
    } = this.props;

    if (fallback) {
      return fallback;
    } else {
      return /*#__PURE__*/_jsx(UIErrorMessage, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "errors.genericError"
        })
      });
    }
  }

  render() {
    const {
      hasError
    } = this.state;

    if (hasError) {
      return this.renderError();
    } else {
      return this.props.children;
    }
  }

}

GenericErrorBoundary.propTypes = {
  children: PropTypes.node.isRequired,
  fallback: PropTypes.node
};
export default GenericErrorBoundary;